import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Banner(props) {
  return (
    <div className="service_usa" style={{ backgroundColor: "#281d40" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1>Magento Development Services</h1>
              <p>
                As a leading Magento development agency, TekRevol offers
                tailored solutions to promote your e-commerce venture. Our
                dedicated team crafts seamless experiences, leveraging Magento's
                prowess to build scalable, high-performing online stores. From
                customizations to integrations, we ensure your brand stands out
                in the digital realm, driving growth and customer satisfaction.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Begin Magento Journey With Us
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-auto">
            <StaticImage
              src="../../images/services-usa/magento/banner_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={775}
              height={650}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
